import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import store from './store';

/**
 * @description plugin Vue Toastification - https://vue-toastification.maronato.dev/
 */
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import {PluginOptions} from 'vue-toastification/dist/types/src/types';

const options: PluginOptions = {
    draggable: false,
    newestOnTop: true,
    filterBeforeCreate: (toast, toasts) => {
        if (toasts.filter(
            t => t.type === toast.type
        ).length !== 0) {
            // Returning false discards the toast
            return false;
        }
        // You can modify the toast if you want
        return toast;
    }
};
Vue.use(Toast, options);


// @ts-ignore
const VueTheMask = require('vue-the-mask');
Vue.use(VueTheMask.default);

import '@/assets/style/index.scss';

import Navbar from '@/components/Navbar.vue';
import Checkradio from '@/components/Checkradio.vue';
import Notification from '@/components/Notification.vue';
import {OmniUsuarioEnum} from '@/helpers/omni-usuario.enum';
import {Client} from '@/client';
import DialogModalPlugin from '@/plugins/DialogModalPlugin';

Vue.component('navbar', Navbar);
Vue.component('checkradio', Checkradio);
Vue.component('notification', Notification);
Vue.use(DialogModalPlugin);

Vue.config.productionTip = false;

const urlSearchParams = new URLSearchParams(window.location.search);
let clientId = urlSearchParams.get('client_id');
let rota = Client.getRouter(clientId);

new Vue({
    router: rota,
    store,
    render: (h) => h(App),
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        localStorage.setItem(OmniUsuarioEnum.OMNI_KEYCLOAK_REDIRECTURI, urlParams.get('redirect_uri') || '');
        localStorage.setItem(OmniUsuarioEnum.OMNI_KEYCLOAK_CLIENTID, urlParams.get('client_id') || '');
        localStorage.setItem(OmniUsuarioEnum.NO_BAR, urlParams.get('no_bar') || '');
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus();
            }
        }
    }
}).$mount('#app');





